export class UserConfig {
  constructor(data = {}) {
    this.user_id = data['user_id'] || null;
    this.is_demo_mode_voice_service = !!data['is_demo_mode_voice_service'];
    this.referral_percent_bonus = data['referral_percent_bonus'] || null;
    this.referral_voice_rate_id = data['referral_voice_rate_id'] || null;
    this.webhook_incoming_sms = data['webhook_incoming_sms'] || null;
    this.webhook_sms_state = data['webhook_sms_state'] || null;
    this.webhook_sms_verification = data['webhook_sms_verification'] || null;
    this.limit_pbx_count = data['limit_pbx_count'] || null;
    this.limit_trunk_count = data['limit_trunk_count'] || null;
    this.calltracking_freeze_minutes_count = data['calltracking_freeze_minutes_count'] || null;
    this.price_change_notifications = data['price_change_notifications'] || null;
    this.show_low_balance_notification = data['show_low_balance_notification'] || false;
    this.available_payment_methods = Array.isArray(data['payment_methods'])
      ? data['payment_methods']
      : [];
  }
}
